module.exports = __webpack_public_path__ + "img/img_Colleges0.1b96a83b.jpg";